import type { getProductModalComponent } from "@/lib/api/formatting/rorosTweed/productPage";

import UI from "./UI";

type Props = {
  show: boolean;
  data: ReturnType<typeof getProductModalComponent>["data"] | undefined;
};

const ProductModal = ({ show, data }: Props) => {
  const scrollToTop = () => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  return <UI show={show} data={data} scrollToTop={scrollToTop} />;
};

export default ProductModal;
